import { Moment } from 'moment-timezone';

import { Time } from './time';

export interface DeviceGPSStatus {
  id: string;
  lat: number;
  lon: number;
  time: Time;
  heading: number;
  pdop: number;
}

export interface DeviceLTEStatus {
  rsrp: string;
  rsrq: number;
  rssi: number;
  sinr: number;
  time: Time;
}

export interface DeviceWiFiStatus {
  level: number;
  link: number;
  noise: number;
  status: number;
  time: Time;
}

export enum DevicePartStatusEnum {
  NONE = 'none',
  UNKNOWN = 'unknown',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export interface DevicePart {
  status: DevicePartStatusEnum;
  time: Time;
}

export interface DeviceParameter {
  used_percent: number;
  time: Time;
}

export enum DeviceStatusFromLastSeenEnum {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  INACTIVE = 'INACTIVE',
}

export enum StatusColors {
  GREEN = '#1AA053',
  ORANGE = '#FF9D0A',
  GRAY = '#B3B2B2',
}

export interface DeviceStatus {
  id: string;
  vehicle_id: string;
  vehicle_name: string;
  route_id: string;
  route_name: string;
  gps: DeviceGPSStatus;
  lte: DeviceLTEStatus;
  wireless: DeviceWiFiStatus;
  able: DevicePart;
  camera: DevicePart;
  last_seen: Moment;
  last_seen_status: DeviceStatusFromLastSeenEnum;
  last_seen_status_color: StatusColors;
  cpu: DeviceParameter;
  gpu: DeviceParameter;
  ram: DeviceParameter;
}

export interface Device {
  id: string;
  sim_number: string | null;
  serial_number: string;
  comment?: string | null;
  vehicle_id?: number | null;
  vehicle_name?: string;
  provisioning_expiration?: Time;
  status?: DeviceStatus;
  updated_at?: Time;
  created_at?: Time;
  route_id?: number;
  ota_group_id?: number;
  ota_group_name?: string;
  device_hw_version_id?: number | null;
  camera_version_id?: number | null;
}
